<template>
  <div class="increment-box-wrap">
    <img
      class="increment-bg"
      :src="bgImg"
      alt="发照片"
      @click="handleSendPhoto"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sendPhoto from '@/mixins/send_photo'

export default {
  name: 'IncrementBox',
  mixins: [sendPhoto],
  data() {
    return {
      entrance: 'control_vip_photo',
      bgImg: 'https://qncweb.ktvsky.com/20260113/vadd/c2664c9494a570d902e38c5affcd2573.png', // 价格9.9元
    }
  },
  computed: {
    ...mapState({
      openid: (state) => state.openid,
      unionid: (state) => state.unionid,
      bless_path: (state) => state.bless_path,
      photoPath: (state) => state.photoPath,
      photo_interact_path_new: (state) => state.photo_interact_path_new,
    }),
  },
  methods: {
    handleSendPhoto() {
      // 直接调用mixin中的handleSend方法
      // 传入入口类型，可自定义
      this.$sendLog({
        event_type: 'click',
        event_name: '发照片弹窗-点击',
        event_data: {
          fromType: 'control_vip',
          name: this.photoPath?.label || '',
        }
      })
      this.$emit('buyPrivilege')
    },
  },
  mounted() {
    this.$sendLog({
      event_type: 'click',
      event_name: '发照片弹窗-展示',
      event_data: {
        fromType: 'control_vip',
        name: this.photoPath?.label || '',
      }
    })
  },
}
</script>

<style scoped>
.increment-box-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.increment-bg {
  width: 750px;
  cursor: pointer;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  transition: box-shadow 0.2s;
}
.increment-bg:active {
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
}
</style>
